import { BaseEntity } from '../base-entity';
import { DataRefresh } from './data-refresh';
import { Dataset } from './dataset';
import { PbiDataset } from './pbi-dataset';
import { PbiRefreshMessage } from './pbi-refresh-message';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export interface PbiDatasetRefresh {
  id: string;
  attemptedAt: Date;
  dataRefreshId: string;
  datasetId: string;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;
  pbiDatasetId?: string;
  pbiDatasetNameAtAttempt: string;
  pbiRefreshId?: string;
  pbiRefreshStatus?: string;
  pbiServiceExceptionJson?: string;
  pbiWorkspaceNameAtAttempt: string;
  settledAt?: Date;
  startedAt?: Date;
  status: string;
  tenantKey: string;
  pbiRefreshMessages: PbiRefreshMessage;
  dataRefresh: DataRefresh;
  dataset: Dataset;
  pbiDataset: PbiDataset;
}

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PbiDatasetRefresh extends BaseEntity {
  /// <code> Place custom code between <code> tags
  /// </code>
  // Generated code. Do not place code below this line.
}
